export default {
    bind: function (el, binding, vnode) {
        const marker = document.createElement("div");

        el.appendChild(marker);

        el.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    el.removeChild(marker);
                    vnode.context[binding.expression](entry);
                    el.appendChild(marker);
                }
            });
        });

        el.observer.observe(marker);
    },
    unbind: function (el) {
        if (el.observer) {
            el.observer.disconnect();
        }
    }
};